<template>
  <CustomPage titleType="img">
    <div slot="content" style="height: 100%">
      <div
        class="brandlist flex flex-col"
        style="height: 100%; background-color: #f7f7f7"
      >
        <div class="flex flex-row flex-no-wrap flex-grow">
          <Sidebar v-model="activeCate" class="flex-shrink-0">
            <SidebarItem
              v-for="item in cateList"
              :key="item.cateId"
              :title="item.cateName"
              @click="changeCate(item.cateId)"
            />
          </Sidebar>
          <div class="flex-grow">
            <Tabs
              v-model="activeStatus"
              background="transparent"
              class="px-12"
              @change="changeStatus"
            >
              <Tab name="预告"
                ><template #title>
                  <span class="text-base font-semibold">预告</span>
                </template></Tab
              >
              <Tab name="热卖"
                ><template #title>
                  <span class="text-base font-semibold">热卖</span>
                </template></Tab
              >
            </Tabs>
            <div class="bg-white mx-3 my-4 lightshadow rounded-lg px-3 py-4">
              <div class="text-left font-semibold text-sm">
                {{ activeStatus
                }}<img class="inline" src="@/assets/brandlist/hot.svg" alt="" />
              </div>
              <div class="flex flex-row justify-start flex-wrap">
                <div
                  v-for="item in brandList"
                  :key="item.signBrandId"
                  class="w-1/3 box-border inline-block px-3 my-4 text-center"
                  style="max-width: 100px"
                  @click="goBrandPlace(item)"
                >
                  <VImage
                    height="59"
                    width="59"
                    :src="item.brandLogo"
                    round
                    alt=""
                    class="shadow-lg"
                  />
                  <div class="text-sm">{{ item.brandName }}</div>
                  <div class="text-xs text-red">{{ item.goodsNum }}款</div>
                  <div
                    v-show="activeStatus === '热卖'"
                    class="text-xxs text-gray"
                    style="white-space: nowrap"
                  >
                    距离结束{{
                      (
                        (dayjs(item.end).toDate() - new Date()) /
                        8.64e7
                      ).toFixed(0)
                    }}天
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Sidebar, SidebarItem, Tab, Tabs, Image as VImage } from "vant";
import { getPlatFormCate, getbrand } from "./webApi";
export default {
  name: "BrandList",
  components: {
    CustomPage,
    Sidebar,
    SidebarItem,
    Tab,
    Tabs,
    VImage,
  },
  created() {
    let state = this.$store.state.piecemeal.brandList;

    getPlatFormCate().then(({ data }) => {
      this.cateList = data;
      this.activeCate = state.activeCate;
      this.activeCateId = state.activeCateId || data[0].cateId;
      this.activeStatus = state.activeStatus;
      this.getBrand();
    });
  },
  data() {
    return {
      activeCate: null,
      activeCateId: null,
      activeStatus: null,

      cateList: [],
      brandList: [],
    };
  },
  methods: {
    changeCate(id) {
      console.log("id", id);
      this.activeCateId = id;

      this.getBrand();
    },
    changeStatus(name) {
      console.log("name", name);
      this.activeStatus = name;
      this.getBrand();
    },
    getBrand() {
      getbrand({
        platformCateId: this.activeCateId,
        type: this.activeStatus === "预告",
      }).then(({ data }) => {
        this.brandList = data;

        this.$store.commit("piecemeal/CHANGE_BRANDLIST_STATE", {
          activeCate: this.activeCate,
          activeCateId: this.activeCateId,
          activeStatus: this.activeStatus,
        });
      });
    },
    goBrandPlace(item) {
      this.$router.push({
        name: "BrandPlace",
        params: { partId: item.partId },
        query: {
          actId: item.actId,
          brandId: item.brandId,

          signBrandId: item.signBrandId,
          brandLogo: item.brandLogo,
        },
      });
    },
  },
};
</script>

<style>
.brandlist .van-sidebar {
  background-color: #fff;
}
.brandlist .van-nav-bar__content {
  background-color: #c82d26;
}
.brandlist .van-sidebar-item {
  background-color: #fff;
}
.brandlist .van-sidebar-item--select {
  background-color: #f7f8fa;
}
.brandlist .van-sidebar-item--select::before {
  height: 24px;
  margin-left: 8px;
  width: 3px;
}
</style>